import { defineStore } from "pinia";
import { useLocalStorage, StorageSerializers } from "@vueuse/core";
import { $http } from "@/plugins/api";

import type { Policy } from "./authorisation.types";

const LOCAL_STORAGE_POLICY_KEY = "store_authorisation_policy";

const useAuthorisationStore = defineStore("authorisation", () => {
  const policy = useLocalStorage<Policy | null>(
    LOCAL_STORAGE_POLICY_KEY,
    null,
    {
      serializer: StorageSerializers.object,
    },
  );

  async function fetchPolicy() {
    try {
      const res = await $http.get<Policy[]>(
        `${import.meta.env.VITE_API_CLIENT}/v1/rbacker/policies`,
      );

      // There is no support of the multiple roles at the moment.
      setPolicy(res.data[0]);
    } catch {
      setPolicy(null);

      throw new Error("useAuthorisationStore error: While fetching policy");
    }
  }

  function setPolicy(newPolicy: Policy | null) {
    policy.value = newPolicy;
  }

  return { policy, fetchPolicy, setPolicy };
});

export { useAuthorisationStore };
